import { useIsAdmin } from '@/hooks'
import { FC } from 'react'

import { AdminLogin } from './admin'
import { ActivityLogin } from './user'

/**
 * 登录界面
 *
 * @returns login page
 */
export const Login: FC = () => {
  const isAdmin = useIsAdmin()

  return isAdmin ? <AdminLogin /> : <ActivityLogin />
}
